// extracted by mini-css-extract-plugin
export var container = "tool-tip-badge-module--container--7c33c";
export var description = "tool-tip-badge-module--description--ac959";
export var medal = "tool-tip-badge-module--medal--de760";
export var quickTip = "tool-tip-badge-module--quick-tip--7f1e8";
export var root = "tool-tip-badge-module--root--5a9f5";
export var title = "tool-tip-badge-module--title--3eb8b";